<script>
  import { page } from '@inertiajs/inertia-svelte'
  import Icon from '@/Shared/Icon.svelte'

  let leave = false

  $: flash = $page.props.flash
  $: errors = $page.props.errors

  $: if (flash.success) {
    animate()
  }

  $: if (flash.error || (Object.keys(errors).length > 0)) {
    animate()
  }

  function close() {
    reset()
  }

  let leaveTimeout
  let resetTimeout
  function animate() {
    if (!leave) {
      clearTimeout(leaveTimeout)
      clearTimeout(resetTimeout)
      leaveTimeout = setTimeout(() => {
        leave = true
        resetTimeout = setTimeout(() => {
          reset()
        }, 1000)
      }, 30000)
    }
  }

  function reset() {
    clearTimeout(leaveTimeout)
    clearTimeout(resetTimeout)
    flash = {
      success: null,
      error: null
    }
    errors = {}
    leave = false
  }
</script>

<!-- {(console.log(flash), '')}
{(console.log(errors), '')} -->

{#if flash.success}
  <div class="mb-8 flex items-center justify-between bg-green-500 rounded max-w-3xl transition-all duration-500 ease-in-out relative {leave ? '-right-full opacity-0' : '-right-0 opacity-100'}">
    <div class="flex items-center">
      <Icon name="success" class="ml-4 mr-2 flex-shrink-0 w-5 h-5 fill-white" />
      <div class="py-4 text-white text-sm font-medium">{flash.success}</div>
    </div>
    <button type="button" class="group mr-2 p-2" on:click={reset}>
      <Icon name="close" class="w-5 h-5 fill-white" />
    </button>
  </div>
{/if}

{#if flash.error || (Object.keys(errors).length > 0)}
  <div class="mb-8 flex items-center justify-between bg-red-500 rounded max-w-3xl transition-all duration-500 ease-in-out {leave ? '-right-full opacity-0' : '-right-0 opacity-100'}">
    <div class="flex items-center">
      <Icon name="error" class="ml-4 mr-2 flex-shrink-0 w-5 h-5 fill-white" />
      {#if flash.error}
        <div class="py-4 text-white text-sm font-medium">{flash.error}</div>
      {:else}
        <div class="py-4 text-white text-sm font-medium">
          {#if Object.keys(errors).length === 1}
            <span>Il y a une erreur dans ce formulaire.</span>
          {:else}
            <span>Il y a {Object.keys(errors).length} erreurs via les données saisies.</span>
          {/if}
        </div>
      {/if}
    </div>
    <button type="button" class="group mr-2 p-2" on:click={reset}>
      <Icon name="close" class="w-5 h-5 fill-white" />
    </button>
  </div>
{/if}
